export const flipCardClass: string = '.flipcard';
export const flipCardContainerClass: string = '.flipcard-container';
export const flipCardTitleClass: string = '.flipcard-title';
export const flipCardResetBtnClass: string = '.flipcard-btn-reset';
export const flipCardFaceClass: string = '.flipcard-face';
export const flipCardFrontFaceClass: string = '.flipcard-front';
export const flipCardContentClass: string = '.flipcard-content';
export const flipCardContentOptionsClass: string = '.flipcard-content-options';
